export const incomeFund = {
    code: 'FNBIF',
    expectedReturn: 0.06,
    term: 2,
    scenarios: {
        1: { down: 0.00303990191522134, expected: 0.00626500204476159, up: 0.00948854337450193 },
        2: { down: 0.00496101227085203, expected: 0.00620783536120354, up: 0.00864343334147548 },
    },
};
